import React, { useEffect, useState } from "react";
import classes from "./App.module.css";

import { Route, Routes, Navigate } from "react-router-dom";

//Pages
import Home from "./components/Pages/Home";
import Clinics from "./components/Pages/Clinics";
import Services from "./components/Pages/Services"
import Rehab from "./components/Pages/Rehab"

import axios from "axios";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import School from "./components/Pages/School";
import Exhibitions from "./components/Pages/Exhibitions";

function App() {
  return (
    <div className={classes.App}>
      <Routes>
        {/* <Route path="/" element={<Navigate to="/home" />} /> */}
        <Route path="/" element={<Home />} />
        <Route path="/clinics" element={<Clinics />} />
        <Route path="/diagnostic" element={<Services />} />
        <Route path="/rehabilitation" element={<Rehab />} />
        <Route path="/school" element={<School />} />
        <Route path="/exhibitions" element={<Exhibitions />} />
      </Routes>
    </div>
  );
}
export default App;
